import { useContext } from "react";
import { Link } from "react-router-dom";
import { LoginContext } from "context/Auth/LoginContext";
const Terms = ({ t }) => {
  const { isLoggedIn } = useContext(LoginContext);
  return (
    <div className="bg-[#333] rounded-md py-3 w-full mt-10">
      <ul className="flex flex-col sm:flex-row text-white justify-center items-center gap-y-3 sm:gap-x-4 md:gap-x-6 lg:gap-x-10 ">
        {isLoggedIn ? (
          <Link to="/my-account">{t("navigation.myAccount")}</Link>
        ) : (
          <Link to="/login">{t("modals.login.title")}</Link>
        )}
        <span className="text-white hidden sm:block">|</span>
        <Link to="/privacy-policy">
          {t("common.privacyPolicy", "Privacy Policy")}
        </Link>
        <span className="text-white hidden sm:block">|</span>
        <Link to="/terms">{t("common.terms", "Terms & Conditions")}</Link>
      </ul>
    </div>
  );
};

export default Terms;
